export default __webpack_public_path__ + "static/media/sweep.54d9fdaa.png";